<template>
  <b-modal
    :id="id"
    size="lg"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
    @ok="close"
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="people"></b-icon>
        <span>Modifica una {{ title }} </span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="
          cancel();
          close();
        "
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>
    <validation-observer class="mt-3" ref="observer1" v-slot="{ handleSubmit, invalid }">
      <b-form @submit.prevent="">
        <div class="form-card-wrapper">
          <b-card header-tag="header">
            <template #header>
              <b>Dati Generali</b>
            </template>
            <b-card-text>
              <b-row>
                <div class="form-group">
                  <base-input
                    :name="beFormEdit[rep].attribute_FULN_value.label"
                    vid="attribute_FULN_value"
                    :label="beFormEdit[rep].attribute_FULN_value.label"
                    v-model="inputVal[rep].attribute_FULN_value"
                    placeholder="Inserisci un nome"
                    :rules="{ required: true }"
                    :disabled="true"
                  />
                </div>
                <div class="form-group">
                  <base-input
                    :name="beFormEdit[rep].attribute_NINO_value.label"
                    vid="attribute_NINO_value"
                    :label="beFormEdit[rep].attribute_NINO_value.label"
                    v-model="inputVal[rep].attribute_NINO_value"
                    textcase="upper"
                    placeholder="Inserisci un codice fiscale"
                    :rules="getRules('attribute_NINO_value', 'claim_party')"
                    :disabled="isImportedClaim"
                  />
                </div>
                <div class="form-group" v-if="status_claimparty === 3">
                  <base-input
                    :name="beFormEdit[rep].attribute_CREG_value.label"
                    vid="attribute_CREG_value"
                    :label="beFormEdit[rep].attribute_CREG_value.label"
                    v-model="inputVal[rep].attribute_CREG_value"
                    placeholder="Inserisci una ragione sociale"
                    :rules="getRules('attribute_CREG_value', 'claim_party')"
                  />
                </div>
                <div class="form-group" v-if="status_claimparty === 1">
                  <base-input
                    :name="beFormEdit[rep].attribute_CPINS_value.label"
                    vid="attribute_CPINS_value"
                    :label="beFormEdit[rep].attribute_CPINS_value.label"
                    v-model="inputVal[rep].attribute_CPINS_value"
                    placeholder="Inserisci una compagnia"
                    :disabled="isImportedClaim"
                  />
                </div>
                <div class="form-group" v-if="status_claimparty === 1">
                  <base-input
                    :name="beFormEdit[rep].attribute_CPRGP_value.label"
                    vid="attribute_CPRGP_value"
                    :label="beFormEdit[rep].attribute_CPRGP_value.label"
                    v-model="inputVal[rep].attribute_CPRGP_value"
                    placeholder="Inserisci una targa"
                  />
                </div>
                <div class="form-group" v-if="status_claimparty === 1">
                  <base-input
                    :name="beFormEdit[rep].attribute_CPVEH_value.label"
                    vid="attribute_CPVEH_value"
                    :label="beFormEdit[rep].attribute_CPVEH_value.label"
                    v-model="inputVal[rep].attribute_CPVEH_value"
                    placeholder="Inserisci un veicolo"
                  />
                </div>
              </b-row>
            </b-card-text>
          </b-card>
        </div>
        <div class="form-card-wrapper">
          <address-book-form
            v-model="address_book_form"
            :beECForm="beFormEdit[addrBook]"
            :repository="addrBook"
            :disabled="isImportedClaim"
          ></address-book-form>
        </div>
        <div class="form-card-wrapper">
          <correspondence-form
            v-model="correspondence_form"
            :beECForm="beFormEdit[cor]"
            :repository="cor"
            :disabled="isImportedClaim"
          >
        </correspondence-form>
        </div>
        <b-button
          @click="handleSubmit(update)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          class="mt-2 mb-2 float-right"
        >
          Aggiorna
        </b-button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script>
import BaseInput from "@/components/form/BaseInput";
import AddressBookForm from "@/components/form/AddressBookForm";
import CorrespondenceForm from "@/components/form/CorrespondenceForm";
import AddresBookCorrespondenceMixin from "@/mixins/AddressBookCorrespondenceMixin";
import FormMixin from "@/mixins/FormMixin";
import {mapGetters} from "vuex";
import BaseIcon from "@/components/BaseIcon";

export default {
  mixins: [FormMixin, AddresBookCorrespondenceMixin],
  data() {
    return {
      repository: "claim_party",
      isLoading: true,
      foreignCouncilId: null,
      address_book_id: null,
      correspondence_id: null,
      opt_councils: [],
      optHomeCountries: [],
      optHomeProvinces: [],
      optHomeCouncils: [],
      defaultCountryName: "Italia",
    };
  },
  props: {
    id: {
      type: String,
      default: "editClaimPartyModal",
    },
    title: {
      type: String,
    },
    status_claimparty: {
      type: Number,
    },
    value: null,
    beRulesEdit: {
      type: Object,
      default() {
        return {};
      },
    },
    beFormEdit: {
      type: Object,
      default() {
        return {};
      },
    },
    isImportedClaim: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BaseInput,
    AddressBookForm,
    CorrespondenceForm,
    BaseIcon,
  },
  computed: {
    rep() {
      return "claim_party";
    },
    cor() {
      return "correspondence";
    },
    addrBook() {
      return "address_book";
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    update() {
      this.$emit("update", this.inputVal);
    },
    close() {
      this.$emit("close", this.inputVal);
    },
    ...mapGetters("auth", [
      "countries",
      "provinces",
      "provinceByProvinceId",
      "countries",
      "provinces",
      "councils",
    ]),
  },
  beforeMount() {
    this.beRules["claim_party"] = this.beRulesEdit["claim_party"];
    this.beRules["address_book"] = this.beRulesEdit["address_book"];
    this.beRules["correspondence"] = this.beRulesEdit["correspondence"];
    this.form = this.inputVal;
  },
};
</script>
<style lang="scss" scoped></style>
